module.exports = __webpack_public_path__ + "static/media/photoCredit.71def936.svg";